import React from "react";
import { Route, Routes } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import * as routes from "./routes";
import { Layout, Common } from "./Components";
import { UserContextProvider } from "./Context";
import { ProfilePages, AuthenticatePages, UserPages, TrackerPages } from "./Pages";
import { NotFound } from "./Components/Common"

function App() {
  return (
    <>
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          loading: {
            icon: <Common.Spinner size={4} />,
          },
        }}
      />
      <UserContextProvider>
        <Routes>
          <Route path={routes.HOME} element={<Layout.Layout />}>
            <Route path={routes.HOME} element={<TrackerPages.Home />} />
            <Route path={routes.VIEW_DAY} element={<TrackerPages.ViewDay />} />
            <Route path={routes.START} element={<TrackerPages.StartDay />} />
            <Route path={routes.END} element={<TrackerPages.EndDay />} />
            <Route path={routes.ADD_TASK} element={<TrackerPages.AddTask />} />
            <Route path={routes.MARK_COMPLETE} element={<TrackerPages.MarkComplete />} />
            <Route path={routes.USERS} element={<UserPages.UserListPage />} />
            <Route path={routes.PROFILE} element={<ProfilePages.Profile />} />
            <Route path={routes.UNKNOWN_ROUTE} element={<NotFound />} />
          </Route>
          <Route path={routes.LOGIN} element={< Layout.PublicLayout />} >
            <Route path={routes.LOGIN} element={< AuthenticatePages.LoginForm />} />
          </Route>
          <Route path={routes.SIGNUP} element={<Layout.PublicLayout />}>
            <Route path={routes.SIGNUP} element={<AuthenticatePages.SignUpForm />} />
          </Route>
        </Routes>
      </UserContextProvider>
    </>
  );
}

export default App;
